import type {FC} from 'react'
import {useMemo} from 'react'

export interface FileListProps {
    files: File[]
}

function list(files: File[]) {
    const label = (file: File) =>
        //`'${file.name}' of size '${file.size}' and type '${file.type}'`
        `'${file.name}'`
    return files.map((file) => {
        if (file) {
            return <li key={file.name} className="mt-4"><strong>{label(file)}</strong></li>
        } else return undefined;
    })
}

export const FileList: FC<FileListProps> = ({files}) => {
    const fileList = useMemo(() => list(files), [files])
    if (files.length === 0) {
        return <></>;//<div>Nothing to display</div>
    }
    return <div>{fileList}</div>
}